"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var parameters_1 = __importDefault(require("./config/parameters"));
var lodash_1 = __importDefault(require("lodash"));
var dayjs_1 = __importDefault(require("dayjs"));
var localeData_1 = __importDefault(require("dayjs/plugin/localeData"));
var customParseFormat_1 = __importDefault(require("dayjs/plugin/customParseFormat"));
require("dayjs/locale/es");
require("dayjs/locale/de");
require("dayjs/locale/en");
require("dayjs/locale/fr");
require("dayjs/locale/hu");
require("dayjs/locale/it");
require("dayjs/locale/pt");
require("dayjs/locale/ro");
require("dayjs/locale/sk");
var TripEditor = /** @class */ (function () {
    function TripEditor(route, routeDataForChanges, i18nLocale, startDate, endDate, localities) {
        if (localities === void 0) { localities = null; }
        dayjs_1.default.extend(localeData_1.default);
        dayjs_1.default.extend(customParseFormat_1.default);
        dayjs_1.default.locale(i18nLocale);
        this.route = route;
        this.alternativePointsOfInterest = [];
        this.currentDayAlternativePointsOfInterest = [];
        this.routeDataForChanges = routeDataForChanges;
        this.localities = localities;
        this.days = [];
        this.daySelected = null;
        this.startDate = startDate;
        this.endDate = endDate;
        this.rawDateSelected = "";
        this.routeHasChanged = false;
        this.clonedRoute = lodash_1.default.cloneDeep(this.route);
        this.clonedRouteDataForChanges = lodash_1.default.cloneDeep(this.routeDataForChanges);
        this.clonedLocalities = lodash_1.default.cloneDeep(this.localities);
        this.alternativeSelectionErrorMessage = null;
    }
    TripEditor.prototype.init = function () {
        this.setDaysList();
        this.updateDateSelected();
        this.routeSort();
    };
    // region internal getters
    TripEditor.prototype.getAlternativePoiDataForChanges = function (id) {
        var _a;
        return (_a = this.routeDataForChanges.alternative_pois.find(function (poi) { return poi.id == id; })) !== null && _a !== void 0 ? _a : null;
    };
    TripEditor.prototype.getPlannedPoiDataForChanges = function (id) {
        var _a;
        return (_a = this.routeDataForChanges.planned_pois.find(function (poi) { return poi.id == id; })) !== null && _a !== void 0 ? _a : null;
    };
    TripEditor.prototype.getLocalityDataForChanges = function (day, wof_id) {
        var _a, _b;
        return (_b = (_a = this.routeDataForChanges.localities) === null || _a === void 0 ? void 0 : _a.find(function (loc) { return loc.day == day && loc.wof_id == wof_id; })) !== null && _b !== void 0 ? _b : null;
    };
    TripEditor.prototype.getRoutePoi = function (id) {
        var _a;
        return (_a = this.route.route_points_of_interest.find(function (poi) { return poi.point_of_interest.id == id; })) !== null && _a !== void 0 ? _a : null;
    };
    TripEditor.prototype.getAlternativePoi = function (id) {
        var _a;
        return (_a = this.alternativePointsOfInterest.find(function (poi) { return poi.id == id; })) !== null && _a !== void 0 ? _a : null;
    };
    // endregion
    // region utils
    TripEditor.prototype.getStartingHour = function (day) {
        return parameters_1.default.defaultStartingHour;
    };
    TripEditor.prototype.updateRouteDataForChangesWithDeletion = function (id) {
        var index = this.routeDataForChanges.planned_pois.findIndex(function (poi) { return poi.id === id; });
        var deletedPoiDataForChanges = this.routeDataForChanges.planned_pois.splice(index, 1)[0];
        this.routeDataForChanges.alternative_pois.push(deletedPoiDataForChanges);
    };
    TripEditor.prototype.updateRouteDataForChangesWithAddition = function (id) {
        // Move the poi from planned_pois to alternative_pois list
        var index = this.routeDataForChanges.alternative_pois.findIndex(function (x) { return x.id === id; });
        var addedPoiDataForChanges = this.routeDataForChanges.alternative_pois.splice(index, 1)[0];
        this.routeDataForChanges.planned_pois.push(addedPoiDataForChanges);
    };
    TripEditor.prototype.updatePosition = function () {
        var _this = this;
        this.route.route_points_of_interest.sort(function (a, b) { var _a, _b, _c, _d, _e, _f; return a.day - b.day || ((_c = (_b = _this.getPlannedPoiDataForChanges((_a = a.point_of_interest.id) !== null && _a !== void 0 ? _a : "")) === null || _b === void 0 ? void 0 : _b.absolute_position) !== null && _c !== void 0 ? _c : 0) - ((_f = (_e = _this.getPlannedPoiDataForChanges((_d = b.point_of_interest.id) !== null && _d !== void 0 ? _d : "")) === null || _e === void 0 ? void 0 : _e.absolute_position) !== null && _f !== void 0 ? _f : 0); });
        var currDay = 0, currPos = 0;
        this.route.route_points_of_interest.forEach(function (p) {
            p.position = ((currDay === p.day) ? ++currPos : (currPos = 1));
            currDay = p.day;
        });
    };
    TripEditor.prototype.updateRouteHour = function (day, dayStartingHour) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var _loop_1 = function (poi) {
            var calculatedCostToPoi = (_c = (_b = this_1.getPlannedPoiDataForChanges((_a = poi.point_of_interest.id) !== null && _a !== void 0 ? _a : "")) === null || _b === void 0 ? void 0 : _b.origin_to_poi_cost) !== null && _c !== void 0 ? _c : 0;
            for (var _i = 0, _a = this_1.route.route_points_of_interest.filter(function (x) { return x.day == day && x.position < poi.position; }); _i < _a.length; _i++) {
                var auxPoi = _a[_i];
                var auxPoiDataForChanges = this_1.getPlannedPoiDataForChanges((_d = auxPoi.point_of_interest.id) !== null && _d !== void 0 ? _d : "undefined");
                if (auxPoiDataForChanges == null) {
                    console.log("Unable to get " + (auxPoi === null || auxPoi === void 0 ? void 0 : auxPoi.point_of_interest).translations[0].title);
                    return { value: void 0 };
                }
                calculatedCostToPoi += (_e = auxPoiDataForChanges === null || auxPoiDataForChanges === void 0 ? void 0 : auxPoiDataForChanges.detour_cost) !== null && _e !== void 0 ? _e : 0;
                var duration = "minutes_duration" in auxPoi.point_of_interest && auxPoi.point_of_interest.minutes_duration != null ? auxPoi.point_of_interest.minutes_duration : 0;
                calculatedCostToPoi += duration !== 0 ? duration : parameters_1.default.defaultPointOfInterestMinutesDuration;
            }
            poi.hour = dayjs_1.default(dayStartingHour, "HH:mm:ss").add(calculatedCostToPoi, "minute").format("HH:mm:ss");
        };
        var this_1 = this;
        // Update hours of pois
        for (var _i = 0, _l = this.route.route_points_of_interest.filter(function (poi) { return poi.day == day; }); _i < _l.length; _i++) {
            var poi = _l[_i];
            var state_1 = _loop_1(poi);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        // Update hours of localities
        for (var _m = 0, _o = ((_g = (_f = this.localities) === null || _f === void 0 ? void 0 : _f.filter(function (poi) { return poi.day == day; })) !== null && _g !== void 0 ? _g : []); _m < _o.length; _m++) {
            var loc = _o[_m];
            var localityDataForChanges = this.getLocalityDataForChanges(day, loc.wof_id);
            if (localityDataForChanges == null) {
                console.log("Unable to get locality " + (loc === null || loc === void 0 ? void 0 : loc.wof_id));
                return;
            }
            var calculatedCostToLocality = (_h = localityDataForChanges === null || localityDataForChanges === void 0 ? void 0 : localityDataForChanges.origin_to_locality_cost) !== null && _h !== void 0 ? _h : 0;
            for (var _p = 0, _q = this.route.route_points_of_interest.filter(function (x) { return x.day == day; }); _p < _q.length; _p++) {
                var auxPoi = _q[_p];
                var auxPoiDataForChanges = this.getPlannedPoiDataForChanges((_j = auxPoi.point_of_interest.id) !== null && _j !== void 0 ? _j : "undefined");
                if (auxPoiDataForChanges == null) {
                    console.log("Unable to get " + (auxPoi === null || auxPoi === void 0 ? void 0 : auxPoi.point_of_interest).translations[0].title);
                    return;
                }
                if (auxPoiDataForChanges.absolute_position > localityDataForChanges.absolute_position)
                    continue;
                calculatedCostToLocality += (_k = auxPoiDataForChanges === null || auxPoiDataForChanges === void 0 ? void 0 : auxPoiDataForChanges.detour_cost) !== null && _k !== void 0 ? _k : 0;
                var duration = "minutes_duration" in auxPoi.point_of_interest && auxPoi.point_of_interest.minutes_duration != null ? auxPoi.point_of_interest.minutes_duration : 0;
                calculatedCostToLocality += duration !== 0 ? duration : parameters_1.default.defaultPointOfInterestMinutesDuration;
            }
            loc.hour = dayjs_1.default(dayStartingHour, "HH:mm:ss").add(calculatedCostToLocality, "minute").format("HH:mm:ss");
        }
    };
    TripEditor.prototype.getDate = function (day) {
        if (this.startDate == null)
            return null;
        return dayjs_1.default(this.startDate).add(day - 1, "day").format("YYYY-MM-DD");
    };
    TripEditor.prototype.updatePoisPositionOnAddition = function (day, fromPosition) {
        for (var _i = 0, _a = this.route.route_points_of_interest; _i < _a.length; _i++) {
            var poi = _a[_i];
            if (poi.day == day && poi.position > fromPosition) {
                poi.position++;
            }
        }
    };
    TripEditor.prototype.addAlternativeToRoute = function (pointOfInterest, poiDataForChanges) {
        var _a;
        var previousPoiDataForChanges = null;
        var maxPosition = -1;
        for (var _i = 0, _b = this.routeDataForChanges.planned_pois.filter(function (x) { return x.day == poiDataForChanges.day; }); _i < _b.length; _i++) {
            var poi = _b[_i];
            if (poi.absolute_position > maxPosition) {
                maxPosition = poi.absolute_position;
            }
            if (previousPoiDataForChanges == null && poi.absolute_position < poiDataForChanges.absolute_position) {
                previousPoiDataForChanges = poi;
            }
            else if (previousPoiDataForChanges != null && poi.absolute_position > previousPoiDataForChanges.absolute_position && poi.absolute_position < poiDataForChanges.absolute_position) {
                previousPoiDataForChanges = poi;
            }
        }
        var previousPoi = this.getRoutePoi((_a = previousPoiDataForChanges === null || previousPoiDataForChanges === void 0 ? void 0 : previousPoiDataForChanges.id) !== null && _a !== void 0 ? _a : "");
        var prevPoiPosition = (previousPoi == null) ? 0 : previousPoi.position;
        var prevPoiDate = (previousPoi == null) ? this.getDate(poiDataForChanges.day) : previousPoi.date;
        var startingHour = this.getStartingHour(poiDataForChanges.day);
        this.updateRouteDataForChangesWithAddition(poiDataForChanges.id);
        this.updatePoisPositionOnAddition(poiDataForChanges.day, prevPoiPosition);
        this.route.route_points_of_interest.splice(prevPoiPosition + 1, 0, {
            day: poiDataForChanges.day,
            position: prevPoiPosition + 1,
            point_of_interest: pointOfInterest,
            date: prevPoiDate,
            hour: "00:00:00"
        });
        this.updateRouteHour(poiDataForChanges.day, startingHour);
        return true;
    };
    TripEditor.prototype.checkIfPoiCanBeAdded = function (pointOfInterest, poiDataForChanges) {
        var _a;
        var maxPosition = Math.max.apply(Math, this.route.route_points_of_interest.filter(function (x) { return x.day == poiDataForChanges.day; }).map(function (o) { return o.position; }));
        if (!isFinite(maxPosition)) {
            return true;
        } // There is no POIs in the specified day
        var lastPointOfInterest = this.route.route_points_of_interest.find(function (x) { return (x.day == poiDataForChanges.day && x.position == maxPosition); });
        var lastPoiRouteDataForChanges = this.getPlannedPoiDataForChanges((_a = lastPointOfInterest === null || lastPointOfInterest === void 0 ? void 0 : lastPointOfInterest.point_of_interest.id) !== null && _a !== void 0 ? _a : "");
        if (lastPoiRouteDataForChanges == null) {
            console.log("Unable to get " + (lastPointOfInterest === null || lastPointOfInterest === void 0 ? void 0 : lastPointOfInterest.point_of_interest).translations[0].title);
            return false;
        }
        if (poiDataForChanges.absolute_position < lastPoiRouteDataForChanges.absolute_position) {
            // console.log(`POI is not last, last POI previous time: ${lastPointOfInterest?.hour} + detour:  ${poiDataForChanges.detour_cost} + duration:  ${(pointOfInterest.minutes_duration!=null?pointOfInterest.minutes_duration:60)}`)
            // console.log(`last POI expected ending time after addition: ${dayjs(lastPointOfInterest?.hour, "HH:mm:ss").add(poiDataForChanges.detour_cost + (pointOfInterest.minutes_duration!=null?pointOfInterest.minutes_duration:60), "minute").format("HH:mm:ss")}`)
            if (dayjs_1.default("23:59:59", "HH:mm:ss").diff(dayjs_1.default(lastPointOfInterest === null || lastPointOfInterest === void 0 ? void 0 : lastPointOfInterest.hour, "HH:mm:ss").add(poiDataForChanges.detour_cost + (pointOfInterest.minutes_duration != null ? pointOfInterest.minutes_duration : 60), "minute")) < 0) {
                return false;
            }
        }
        else {
            // console.log(`POI is last, computing cost. Origin to poi: ${poiDataForChanges.origin_to_poi_cost}`)
            var costToPoi = poiDataForChanges.origin_to_poi_cost;
            for (var _i = 0, _b = this.routeDataForChanges.planned_pois.filter(function (x) { return x.day == poiDataForChanges.day; }); _i < _b.length; _i++) {
                var plannedPoiDataForChanges = _b[_i];
                var poi = this.getRoutePoi(plannedPoiDataForChanges.id);
                if (poi == null) {
                    console.log("Unable to get " + plannedPoiDataForChanges.id);
                    return false;
                }
                var duration = "minutes_duration" in poi.point_of_interest && poi.point_of_interest.minutes_duration != null ? poi.point_of_interest.minutes_duration : 60;
                costToPoi += plannedPoiDataForChanges.detour_cost + (duration > 0 ? duration : 60);
                // console.log(`\t POI ${poi.position} computing added cost. Detour: ${plannedPoiDataForChanges.detour_cost}. Duration ${duration > 0 ? duration : 60}`)
            }
            if (dayjs_1.default("23:59:59", "HH:mm:ss").diff(dayjs_1.default(this.getStartingHour(poiDataForChanges.day), "HH:mm:ss").add(costToPoi, "minute")) < 0) {
                return false;
            }
        }
        return true;
    };
    TripEditor.prototype.setDaysList = function () {
        // Get total days from dates if exist
        if (this.startDate != null && this.endDate != null)
            this.days = Array.from({ length: dayjs_1.default(this.endDate).diff(dayjs_1.default(this.startDate), "days") + 1 }, function (_, i) { return i + 1; });
        // Get total days from pois if dates does not exist
        else
            this.days = Array.from({ length: Math.max.apply(Math, this.route.route_points_of_interest.map(function (poi) { return poi.day; })) }, function (_, i) { return i + 1; });
        this.selectDay(1);
    };
    TripEditor.prototype.alternativePoiHasIncompatibilitiesWithTrip = function (altPoiDataForChanges) {
        var _a;
        for (var _i = 0, _b = this.route.route_points_of_interest.filter(function (x) { return x.day == altPoiDataForChanges.day; }); _i < _b.length; _i++) {
            var routePoi = _b[_i];
            if (altPoiDataForChanges.incompatible_with.includes((_a = routePoi.point_of_interest.id) !== null && _a !== void 0 ? _a : "undefined")) {
                return true;
            }
        }
        return false;
    };
    TripEditor.prototype.updateCurrentDayAlternativePointsOfInterest = function () {
        var _this = this;
        var _a;
        this.currentDayAlternativePointsOfInterest = [];
        for (var _i = 0, _b = this.routeDataForChanges.alternative_pois.filter(function (poi) { return poi.day == _this.daySelected; }); _i < _b.length; _i++) {
            var altPoiDataForChanges = _b[_i];
            if (this.alternativePoiHasIncompatibilitiesWithTrip(altPoiDataForChanges)) {
                continue;
            }
            var altPoi = this.getAlternativePoi((_a = altPoiDataForChanges.id) !== null && _a !== void 0 ? _a : "");
            if (altPoi != null) {
                this.currentDayAlternativePointsOfInterest.push(altPoi);
            }
        }
    };
    // endregion
    // region public methods
    TripEditor.prototype.routeHydrate = function (pointsOfInterest) {
        for (var _i = 0, pointsOfInterest_1 = pointsOfInterest; _i < pointsOfInterest_1.length; _i++) {
            var pointOfInterest = pointsOfInterest_1[_i];
            for (var i = 0; i < this.route.route_points_of_interest.length; i++) {
                if (pointOfInterest.id === this.route.route_points_of_interest[i].point_of_interest.id) {
                    this.route.route_points_of_interest[i].point_of_interest = pointOfInterest;
                    break;
                }
            }
        }
    };
    TripEditor.prototype.routeSort = function () {
        var _a;
        this.route.route_points_of_interest.sort(function (backElement, nextElement) {
            return backElement.day < nextElement.day ? 1 : backElement.day > nextElement.day ? -1 : backElement.position < nextElement.position ? 1 : backElement.position > nextElement.position ? -1 : 0;
        });
        (_a = this.localities) === null || _a === void 0 ? void 0 : _a.sort(function (backElement, nextElement) {
            return backElement.day < nextElement.day ? 1 : backElement.day > nextElement.day ? -1 : backElement.position < nextElement.position ? 1 : backElement.position > nextElement.position ? -1 : 0;
        });
    };
    TripEditor.prototype.restore = function () {
        var _a, _b;
        this.route.route_points_of_interest = lodash_1.default.cloneDeep(this.clonedRoute.route_points_of_interest);
        this.routeDataForChanges.planned_pois = lodash_1.default.cloneDeep(this.clonedRouteDataForChanges.planned_pois);
        this.routeDataForChanges.alternative_pois = lodash_1.default.cloneDeep(this.clonedRouteDataForChanges.alternative_pois);
        if (this.clonedLocalities) {
            (_a = this.localities) === null || _a === void 0 ? void 0 : _a.splice(0);
            (_b = this.localities) === null || _b === void 0 ? void 0 : _b.push.apply(_b, lodash_1.default.cloneDeep(this.clonedLocalities));
        }
        this.init();
        this.routeHasChanged = false;
    };
    TripEditor.prototype.selectDay = function (day) {
        this.daySelected = day;
        this.updateDateSelected();
        this.updateCurrentDayAlternativePointsOfInterest();
    };
    TripEditor.prototype.deleteRoutePointOfInterest = function (routePointOfInterest) {
        if (routePointOfInterest.point_of_interest.id == null) {
            return;
        }
        var startingHour = this.getStartingHour(routePointOfInterest.day);
        this.updateRouteDataForChangesWithDeletion(routePointOfInterest.point_of_interest.id);
        var poiIndex = this.route.route_points_of_interest.indexOf(routePointOfInterest);
        var deletedPoi = this.route.route_points_of_interest.splice(poiIndex, 1)[0];
        if (this.alternativePointsOfInterest.filter(function (x) { return x.id == deletedPoi.point_of_interest.id; }).length <= 0) {
            this.alternativePointsOfInterest.push(deletedPoi.point_of_interest);
        }
        this.updatePosition();
        this.updateRouteHour(deletedPoi.day, startingHour);
        this.updateCurrentDayAlternativePointsOfInterest();
        this.routeHasChanged = true;
    };
    TripEditor.prototype.clearDay = function () {
        var _this = this;
        if (!this.daySelected) {
            return;
        }
        for (var _i = 0, _a = this.route.route_points_of_interest.filter(function (x) { return x.day == _this.daySelected; }); _i < _a.length; _i++) {
            var routePoi = _a[_i];
            this.deleteRoutePointOfInterest(routePoi);
        }
    };
    TripEditor.prototype.selectAlternativePointOfInterest = function (pointOfInterest) {
        var _a;
        var poiDataForChanges = this.getAlternativePoiDataForChanges((_a = pointOfInterest.id) !== null && _a !== void 0 ? _a : "");
        if (poiDataForChanges == null) {
            console.log("Unable to get " + pointOfInterest.translations[0].title);
            return false;
        }
        if (!this.checkIfPoiCanBeAdded(pointOfInterest, poiDataForChanges)) {
            return false;
        }
        if (!this.addAlternativeToRoute(pointOfInterest, poiDataForChanges)) {
            return false;
        }
        this.updateCurrentDayAlternativePointsOfInterest();
        this.routeSort();
        this.routeHasChanged = true;
        return true;
    };
    TripEditor.prototype.updateDateSelected = function () {
        if (this.startDate != null)
            this.rawDateSelected = dayjs_1.default(this.startDate).add(this.daySelected ? this.daySelected - 1 : 0, 'd').format('dddd, DD/MM/YYYY');
    };
    TripEditor.prototype.getPoiLocality = function (id) {
        var _a, _b;
        return (_b = (_a = this.localities) === null || _a === void 0 ? void 0 : _a.find(function (loc) { return loc.pois.some(function (poi) { return poi === id; }); })) !== null && _b !== void 0 ? _b : null;
    };
    Object.defineProperty(TripEditor.prototype, "poislocalities", {
        // @ts-ignore. Return list with pois and localities sorted by hour field if they all have it
        get: function () {
            var _this = this;
            var poislocalities = __spreadArrays(this.route.route_points_of_interest, this.localities || []).filter(function (e) { return e.day == _this.daySelected; });
            if (!poislocalities.some(function (e) { return !e.hour || !e.date; }))
                return poislocalities.sort((function (p, n) { return (dayjs_1.default(p.date) > dayjs_1.default(n.date)) ? 1 : (dayjs_1.default(p.date) < dayjs_1.default(n.date)) ? -1 : (p.hour > n.hour) ? 1 : (p.hour < n.hour) ? -1 : 0; }));
            else
                // If the pois/localities don't have hours/date (therefore this is a recommended trip) They will be sorted by position
                return poislocalities.sort((function (p, n) { return (p.position > n.position) ? 1 : (p.position < n.position) ? -1 : 0; }));
        },
        enumerable: false,
        configurable: true
    });
    return TripEditor;
}());
exports.default = TripEditor;
